/* ============================================================
   Bohemians — Core JS
   Vanilla JS. No framework. Keep this small.
   ============================================================ */
(function () {
  'use strict';

  // ---------- Utility: event delegation ----------
  function on(selector, event, handler, root) {
    (root || document).addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target) handler(e, target);
    });
  }

  // ---------- Format money (INR default; Shopify injects currency via theme.settings) ----------
  function formatMoney(cents, currency) {
    var value = (cents / 100).toFixed(2);
    var symbol = currency === 'USD' ? '$' : '₹';
    return symbol + parseFloat(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  window.BohemiansFormatMoney = formatMoney;

  // ---------- Viewport helper ----------
  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  // ---------- Mobile nav ----------
  function initMobileNav() {
    var nav = document.querySelector('.mobile-nav');
    if (!nav) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) { nav.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      if (e.target.closest('[data-menu-close]') || e.target === nav) { nav.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    });
  }

  // ---------- Mobile nav: sub-menu toggle (e.g. "Collections") ----------
  function initMobileNavAccordion() {
    document.querySelectorAll('[data-mobile-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.closest('.mobile-nav__item').querySelector('[data-mobile-nav-body]');
        if (!body) return;
        var open = body.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  // ---------- Cart drawer ----------
  var cartState = { items: [], count: 0 };

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cartState = data;
        updateCartBadge(data.item_count);
        return data;
      });
  }

  function updateCartBadge(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-count', String(count || 0));
      el.textContent = count > 0 ? String(count) : '';
    });
  }

  function escapeAttr(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCart(data) {
    var panel = document.querySelector('[data-cart-content]');
    if (!panel) return;
    var headHTML = '<header class="cart-head">'
      + '<h3>Your cart' + (data.item_count > 0 ? ' (' + data.item_count + ')' : '') + '</h3>'
      + '<button data-cart-close aria-label="Close cart">'
        + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      + '</button>'
      + '</header>';

    if (!data.items || data.items.length === 0) {
      panel.innerHTML = headHTML
        + '<div class="cart-empty">'
          + '<span class="cart-empty__icon" aria-hidden="true">∞</span>'
          + '<h3 class="h3" style="margin:0;">Your cart is empty</h3>'
          + '<p>Find something you love.</p>'
          + '<a class="btn btn--primary" href="/collections/all" data-cart-close>Shop the collection</a>'
        + '</div>';
      return;
    }
    var lines = data.items.map(function (item) {
      var img = item.image ? '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.product_title) + '" loading="lazy">' : '';
      var url = item.url || '/products/' + item.handle;
      return '<div class="cart-line" data-key="' + escapeAttr(item.key) + '">'
        + '<a href="' + escapeAttr(url) + '" class="cart-line__media" data-cart-close>' + img + '</a>'
        + '<div class="cart-line__body">'
          + '<div class="cart-line__head">'
            + '<a href="' + escapeAttr(url) + '" class="cart-line__title" data-cart-close>' + escapeAttr(item.product_title) + '</a>'
            + '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>'
          + '</div>'
          + (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__variant">' + escapeAttr(item.variant_title) + '</div>' : '')
          + '<div class="cart-line__bottom">'
            + '<div class="cart-line__qty">'
              + '<button type="button" data-cart-qty="-1" aria-label="Decrease">−</button>'
              + '<span>' + item.quantity + '</span>'
              + '<button type="button" data-cart-qty="1" aria-label="Increase">+</button>'
            + '</div>'
            + '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Remove ' + escapeAttr(item.product_title) + '">'
              + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>'
              + '<span>Remove</span>'
            + '</button>'
          + '</div>'
        + '</div>'
      + '</div>';
    }).join('');

    var subtotal = formatMoney(data.total_price);
    panel.innerHTML = headHTML
      + '<div class="cart-lines">' + lines + '</div>'
      + '<footer class="cart-foot">'
        + '<div class="cart-foot__row subtotal"><span>Subtotal</span><span>' + subtotal + '</span></div>'
        + '<p class="cart-foot__notes">Shipping &amp; taxes calculated at checkout.</p>'
        + '<a href="/checkout" class="btn btn--primary">Checkout · ' + subtotal + '</a>'
        + '<a href="/collections/all" class="continue-shopping" data-cart-close>Continue shopping</a>'
      + '</footer>';
  }

  function openCart() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.hidden = false;
    // double-RAF to allow CSS transitions to play
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.setAttribute('aria-hidden', 'false'); });
    });
    document.body.style.overflow = 'hidden';
    fetchCart().then(renderCart);
  }

  function closeCart() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 320);
  }

  function bumpCartBadge() {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.classList.remove('cart-count--bump');
      void el.offsetWidth; // force reflow
      el.classList.add('cart-count--bump');
    });
  }

  // ---------- Add-to-bag toast (mobile) ----------
  var toastTimer;
  function showAddToast() {
    var toast = document.querySelector('[data-add-toast]');
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.classList.add('is-visible');
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3200);
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
      if (e.target.closest('[data-cart-close]') || e.target.matches('.cart-drawer__scrim')) closeCart();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    // /cart page: per-line qty stepper updates input + total live
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-page-qty]');
      if (!btn) return;
      e.preventDefault();
      var line = btn.closest('[data-cart-page-line]');
      if (!line) return;
      var span = line.querySelector('[data-qty]');
      var input = line.querySelector('[data-qty-input]');
      var current = parseInt(span.textContent || '1', 10);
      var delta = parseInt(btn.getAttribute('data-page-qty'), 10);
      var next = Math.max(0, current + delta);
      span.textContent = next;
      if (input) input.value = next;
      // ajax update + re-render totals
      var key = line.getAttribute('data-key');
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function (r) { return r.json(); }).then(function (data) {
        updateCartBadge(data.item_count);
        if (next === 0) line.remove();
        document.querySelectorAll('[data-page-subtotal]').forEach(function (el) { el.textContent = formatMoney(data.total_price); });
        document.querySelectorAll('[data-page-total]').forEach(function (el) { el.textContent = formatMoney(data.total_price); });
        // If empty, reload to show empty state
        if (data.item_count === 0) location.reload();
      });
    });

    // Quantity / remove inside cart drawer
    document.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      if (e.target.closest('[data-cart-qty]')) {
        var delta = parseInt(e.target.closest('[data-cart-qty]').getAttribute('data-cart-qty'), 10);
        var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
        updateLine(key, Math.max(0, current + delta));
      }
      if (e.target.closest('[data-cart-remove]')) updateLine(key, 0);
    });

    // Coupon apply (real Shopify /discount/CODE route — no fake math)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-coupon-apply]');
      if (!btn) return;
      var row = btn.closest('.cart-coupon-row');
      var input = row && row.querySelector('[data-coupon-input]');
      var code = input && input.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });

    // AJAX add to cart
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action$="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var data = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('data-loading', '1'); }
      fetch('/cart/add.js', { method: 'POST', body: data, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && res.body.description || 'Add to cart failed');
          return fetchCart().then(function (c) {
            renderCart(c); bumpCartBadge();
            if (isMobileViewport()) { showAddToast(); } else { openCart(); }
          });
        })
        .catch(function (err) { alert(err.message); })
        .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('data-loading'); } });
    });

    fetchCart();
  }

  function updateLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { cartState = data; updateCartBadge(data.item_count); renderCart(data); });
  }

// ---------- Product page: variants + gallery ----------
  function initProductForm() {
    var forms = document.querySelectorAll('[data-product-form]');
    forms.forEach(function (form) {
      var variantsJson = form.querySelector('[data-variants-json]');
      if (!variantsJson) return;
      var variants = JSON.parse(variantsJson.textContent);
      var optionSelectors = form.querySelectorAll('[data-option-index]');

      function getSelectedOptions() {
        var selected = [];
        // Skip the fallback size picker — it's a line-item property, not a real Shopify option
        form.querySelectorAll('.variant-group:not(.variant-group--size-fallback)').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          if (isNaN(idx)) return;
          var chosen = group.querySelector('[aria-checked="true"]');
          selected[idx] = chosen ? chosen.getAttribute('data-value') : null;
        });
        return selected;
      }

      function matchVariant() {
        var opts = getSelectedOptions();
        // If the product has no real variant options (e.g. single-color hidden, or default-only),
        // fall back to the first available variant so the CTA stays enabled.
        var hasSelection = opts.some(function (v) { return v != null; });
        if (!hasSelection) {
          return variants.find(function (v) { return v.available; }) || variants[0];
        }
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === opts[i] || opts[i] == null; });
        });
      }

      function updateVariant() {
        var variant = matchVariant();
        var idInput = form.querySelector('[name="id"]');
        var priceEl = form.querySelector('[data-price]');
        var compareEl = form.querySelector('[data-compare-price]');
        var submitBtn = form.querySelector('[type="submit"]');
        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (compareEl) compareEl.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
          if (submitBtn) {
            submitBtn.disabled = !variant.available;
            submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
          }
          // Variant featured image → jump slider to matching slide (or swap first slide as fallback)
          if (variant.featured_image) {
            var src = variant.featured_image.src || variant.featured_image;
            var gallery = document.querySelector('[data-gallery]');
            if (gallery && typeof gallery.__goToSrc === 'function') {
              gallery.__goToSrc(src);
            }
          }
        } else {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
        }
      }

      form.addEventListener('click', function (e) {
        var chip = e.target.closest('.variant-chip, .color-swatch, .color-swatch-tile');
        if (!chip || chip.classList.contains('color-swatch-tile--link')) return;
        var group = chip.closest('.variant-group');
        group.querySelectorAll('[aria-checked]').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        chip.setAttribute('aria-checked', 'true');
        // Update color label text if this is a color swatch tile / swatch
        if (chip.classList.contains('color-swatch') || chip.classList.contains('color-swatch-tile')) {
          var label = group.querySelector('[data-color-label]');
          if (label) label.textContent = chip.getAttribute('data-value') || '';
        }
        updateVariant();
      });

      updateVariant();
    });
  }

  // ---------- Product gallery slider ----------
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var viewport = g.querySelector('[data-gallery-viewport]');
      var track = g.querySelector('[data-gallery-track]');
      if (!viewport || !track) return;
      var slides = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-slide]'));
      if (slides.length === 0) return;
      var dots = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-dot]'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
      var counter = g.querySelector('[data-gallery-current]');
      var prevBtn = g.querySelector('[data-gallery-prev]');
      var nextBtn = g.querySelector('[data-gallery-next]');
      var index = 0;
      var count = slides.length;

      function go(i) {
        index = Math.max(0, Math.min(count - 1, i));
        track.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
        dots.forEach(function (d, di) {
          var on = di === index;
          d.classList.toggle('is-active', on);
          if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        thumbs.forEach(function (t, ti) {
          var on = ti === index;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = String(index + 1);
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= count - 1;
      }
      g.__galleryGo = go;

      if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-index'), 10) || 0); });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-index'), 10) || 0); });
      });

      // Keyboard nav when focus inside gallery
      g.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      });

      // Touch swipe
      var startX = 0, currentX = 0, dragging = false, startedAt = 0;
      g.__swipedRecently = false;
      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        currentX = startX;
        dragging = true;
        startedAt = Date.now();
        track.classList.add('is-dragging');
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (!dragging || !e.touches || e.touches.length !== 1) return;
        currentX = e.touches[0].clientX;
        var dx = currentX - startX;
        var w = viewport.offsetWidth || 1;
        var pct = (dx / w) * 100;
        // Resistance at edges
        if ((index === 0 && pct > 0) || (index === count - 1 && pct < 0)) pct *= 0.35;
        track.style.transform = 'translate3d(calc(-' + (index * 100) + '% + ' + pct + '%), 0, 0)';
      }, { passive: true });
      viewport.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        var dx = currentX - startX;
        var w = viewport.offsetWidth || 1;
        var elapsed = Date.now() - startedAt;
        var threshold = (elapsed < 250) ? w * 0.12 : w * 0.28; // flick vs drag
        // Flag as swipe so the lightbox click handler can ignore this
        if (Math.abs(dx) > 10) {
          g.__swipedRecently = true;
          setTimeout(function () { g.__swipedRecently = false; }, 400);
        }
        if (dx < -threshold) go(index + 1);
        else if (dx > threshold) go(index - 1);
        else go(index); // snap back
      });

      // Variant featured_image → jump to matching slide
      g.__goToSrc = function (src) {
        if (!src) return;
        var base = String(src).split('?')[0].split('/').pop();
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          if (img && img.src && img.src.indexOf(base) !== -1) { go(i); return; }
        }
      };

      go(0);
    });
  }

  // ---------- Image lightbox ----------
  function initLightbox() {
    var modal = document.querySelector('[data-lightbox]');
    if (!modal) return;
    var stage = modal.querySelector('[data-lightbox-stage]');
    var counter = modal.querySelector('[data-lightbox-counter]');
    var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-lightbox-thumb]'));
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery || !stage) return;

    var sources = Array.prototype.map.call(gallery.querySelectorAll('[data-gallery-slide] img'), function (img) {
      return img.getAttribute('src');
    });
    if (sources.length === 0) return;
    var current = 0;
    var prevFocus = null;

    function render() {
      var src = sources[current];
      if (src && src.indexOf('width=') !== -1) {
        src = src.replace(/width=\d+/, 'width=2000');
      }
      stage.innerHTML = '<img src="' + src + '" alt="" draggable="false">';
      if (counter) counter.textContent = (current + 1) + ' / ' + sources.length;
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === current); });
    }

    function open(idx) {
      current = typeof idx === 'number' ? idx : 0;
      render();
      prevFocus = document.activeElement;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (prevFocus && typeof prevFocus.focus === 'function') prevFocus.focus();
    }

    // Thumbnail clicks inside lightbox
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-index'), 10) || 0;
        current = i; render();
      });
    });
    function next() { current = (current + 1) % sources.length; render(); }
    function prev() { current = (current - 1 + sources.length) % sources.length; render(); }

    // Open on main slide click (but ignore if user just swiped)
    gallery.addEventListener('click', function (e) {
      var slide = e.target.closest('[data-gallery-slide]');
      if (!slide) return;
      if (gallery.__swipedRecently) return;
      var idx = parseInt(slide.getAttribute('data-index'), 10) || 0;
      open(idx);
    });

    modal.querySelector('[data-lightbox-close]').addEventListener('click', close);
    modal.querySelector('[data-lightbox-next]').addEventListener('click', next);
    modal.querySelector('[data-lightbox-prev]').addEventListener('click', prev);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target === stage) close();
    });
    document.addEventListener('keydown', function (e) {
      if (modal.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowRight') { next(); return; }
      if (e.key === 'ArrowLeft') { prev(); return; }
      // Focus trap — keep Tab cycling within modal
      if (e.key === 'Tab') {
        var focusables = modal.querySelectorAll('button');
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Swipe on lightbox
    var sx = 0, dragging = false;
    stage.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      sx = e.touches[0].clientX; dragging = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!dragging) return; dragging = false;
      var ex = (e.changedTouches && e.changedTouches[0].clientX) || sx;
      var dx = ex - sx;
      if (dx < -50) next(); else if (dx > 50) prev();
    });
  }

  // ---------- Sticky mobile buy bar ----------
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    if (!bar) return;
    var anchor = document.querySelector('[data-product-form] [type="submit"]');
    if (!anchor) return;

    function update() {
      // Show only on narrow viewports, after user scrolls past ~320px,
      // AND when the main CTA is off-screen
      var rect = anchor.getBoundingClientRect();
      var ctaOff = rect.bottom < 0 || rect.top > window.innerHeight;
      var narrow = window.innerWidth < 900;
      var scrolled = window.scrollY > 320;
      var active = narrow && scrolled && ctaOff;
      bar.setAttribute('aria-hidden', active ? 'false' : 'true');
      document.body.classList.toggle('sticky-buy-active', active);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var cta = bar.querySelector('[data-sticky-buy-cta]');
    if (cta) cta.addEventListener('click', function () {
      // Proxy to main Add to cart button
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { anchor.click(); }, 320);
    });
  }

  // ---------- Fallback size picker (line item property) ----------
  function initFallbackSize() {
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-fallback-size]');
      if (!chip) return;
      var group = chip.closest('.variant-group--size-fallback');
      if (!group) return;
      group.querySelectorAll('[data-fallback-size]').forEach(function (c) { c.setAttribute('aria-checked', 'false'); });
      chip.setAttribute('aria-checked', 'true');
      var label = group.querySelector('[data-fallback-size-label]');
      var input = group.querySelector('[data-fallback-size-input]');
      var val = chip.getAttribute('data-value');
      var age = chip.getAttribute('data-age');
      if (label) label.textContent = age;
      if (input) input.value = val + ' (' + age + ')';
    });
  }

  // ---------- Quantity stepper ----------
  function initQtyStepper() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var stepper = (minus || plus).closest('[data-qty-stepper]');
      if (!stepper) return;
      var input = stepper.querySelector('[data-qty-input]');
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max') || '99', 10);
      var current = parseInt(input.value || String(min), 10) || min;
      var next = minus ? current - 1 : current + 1;
      next = Math.max(min, Math.min(max, next));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) { input.value = 1; }
    });
  }

  // ---------- Size chart modal ----------
  function initSizeChart() {
    var modal = document.querySelector('[data-size-chart]');
    if (!modal) return;
    function open() {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-chart-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-size-chart-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });
  }

  // ---------- Recently viewed (localStorage) ----------
  function initRecentlyViewed() {
    var STORAGE_KEY = 'bohemians:recently-viewed';
    var MAX = 12;

    function read() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    }
    function push(handle) {
      if (!handle) return;
      var list = read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      write(list);
    }

    // Seed with current product if on product page
    if (window.BohemiansProduct && window.BohemiansProduct.handle) {
      push(window.BohemiansProduct.handle);
    }

    var section = document.querySelector('[data-recently-viewed]');
    var grid = document.querySelector('[data-recently-viewed-grid]');
    if (!section || !grid) return;

    var currentHandle = (window.BohemiansProduct && window.BohemiansProduct.handle) || '';
    var handles = read().filter(function (h) { return h && h !== currentHandle; }).slice(0, 4);
    // Skip entirely unless the user has genuinely visited at least 2 other products
    if (handles.length < 2) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var visible = products.filter(Boolean);
      if (visible.length < 2) return;
      grid.innerHTML = visible.map(function (p) {
        var img = p.featured_image
          ? '<img src="' + escapeAttr(p.featured_image) + '" alt="' + escapeAttr(p.title) + '" loading="lazy" width="600" height="800">'
          : '';
        var compare = (p.compare_at_price && p.compare_at_price > p.price)
          ? '<span class="compare">' + formatMoney(p.compare_at_price) + '</span>' : '';
        return '<a href="' + escapeAttr(p.url) + '" class="product-card">'
          + '<div class="product-card__media">' + img + '</div>'
          + '<div class="product-card__body">'
            + '<div class="product-card__title">' + escapeAttr(p.title) + '</div>'
            + '<div class="product-card__price">'
              + '<span class="price">' + formatMoney(p.price) + '</span>' + compare
            + '</div>'
          + '</div>'
        + '</a>';
      }).join('');
      section.hidden = false;
    });
  }

  // ---------- Pincode checker ----------
  function initPincode() {
    var widgets = document.querySelectorAll('[data-pincode]');
    widgets.forEach(function (w) {
      var input = w.querySelector('input');
      var btn = w.querySelector('button');
      var status = w.querySelector('[data-pincode-status]');
      var endpoint = w.getAttribute('data-endpoint');
      var defaultDays = parseInt(w.getAttribute('data-default-days') || '5', 10);
      if (!btn) return;

      btn.addEventListener('click', function () {
        var pin = (input.value || '').trim();
        status.className = 'pincode-checker__status';
        if (!/^\d{6}$/.test(pin)) {
          status.textContent = 'Enter a valid 6-digit pincode';
          status.classList.add('pincode-checker__status--bad');
          return;
        }
        status.textContent = 'Checking…';
        if (!endpoint) {
          // Fallback: flat-rate / default-day policy
          setTimeout(function () {
            status.textContent = 'Delivery available — arrives in ' + defaultDays + ' days';
            status.classList.add('pincode-checker__status--ok');
          }, 300);
          return;
        }
        fetch(endpoint + '?pincode=' + pin, { credentials: 'omit' })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function (data) {
            if (data.serviceable) {
              status.textContent = 'Delivery available — arrives in ' + (data.days || defaultDays) + ' days';
              status.classList.add('pincode-checker__status--ok');
            } else {
              status.textContent = 'Not serviceable at this pincode yet';
              status.classList.add('pincode-checker__status--bad');
            }
          })
          .catch(function () {
            status.textContent = 'Delivery available — arrives in ' + defaultDays + ' days';
            status.classList.add('pincode-checker__status--ok');
          });
      });
    });
  }

  // ---------- Newsletter (Shopify customer form) ----------
  // Relies on native {% form 'customer' %} — no JS needed unless AJAX desired.

  // ---------- Reviews "Load more" ----------
  function initReviewsMore() {
    var btn = document.querySelector('[data-reviews-more]');
    var dataEl = document.querySelector('[data-reviews-data]');
    var grid = document.querySelector('[data-reviews-grid]');
    if (!btn || !dataEl || !grid) return;
    var all;
    try { all = JSON.parse(dataEl.textContent); } catch(e) { return; }
    var shown = grid.children.length;
    btn.addEventListener('click', function () {
      var batch = all.slice(shown, shown + 6);
      batch.forEach(function (r) {
        var stars = '';
        var rfull = Math.floor(r.rating || 0);
        for (var i = 1; i <= 5; i++) {
          stars += i <= rfull ? '★' : '<span class="star-empty">★</span>';
        }
        var article = document.createElement('article');
        article.className = 'review-card';
        article.innerHTML =
          '<header class="review-card__head"><span class="stars">' + stars + '</span>' +
          (r.verified ? '<span class="review-verified">✓ Verified</span>' : '') + '</header>' +
          (r.title ? '<h3 class="review-card__title">' + escapeHtml(r.title) + '</h3>' : '') +
          '<p class="review-card__text">' + escapeHtml(r.text || '') + '</p>' +
          '<footer class="review-card__foot"><strong>' + escapeHtml(r.name || '') + '</strong>' +
          (r.date ? '<span class="muted"> · ' + escapeHtml(r.date) + '</span>' : '') + '</footer>';
        grid.appendChild(article);
      });
      shown += batch.length;
      if (shown >= all.length) btn.style.display = 'none';
      else btn.textContent = 'Load more reviews (' + (all.length - shown) + ')';
    });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- IntersectionObserver reveal ----------
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('js-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fade-in-up').forEach(function (el) { io.observe(el); });
    // Failsafe: ensure everything is visible after 1.5s even if observer hasn't fired
    setTimeout(function () {
      document.querySelectorAll('.fade-in-up').forEach(function (el) { el.classList.add('is-visible'); });
    }, 1500);
  }

  // ---------- Hero video autoplay enforcer ----------
  function initHeroVideo() {
    var videos = document.querySelectorAll('[data-hero-video]');
    videos.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');

      var playing = false;
      var tryPlay = function () {
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.then(function () { playing = true; v.style.opacity = '1'; })
          .catch(function () {
            var resume = function () {
              v.play().then(function () { playing = true; v.style.opacity = '1'; }).catch(function(){});
              cleanup();
            };
            var cleanup = function () {
              document.removeEventListener('touchstart', resume);
              document.removeEventListener('click', resume);
              document.removeEventListener('scroll', resume);
            };
            document.addEventListener('touchstart', resume, { once: true, passive: true });
            document.addEventListener('click', resume, { once: true });
            document.addEventListener('scroll', resume, { once: true, passive: true });
          });
        } else {
          playing = true;
        }
      };
      if (v.readyState >= 2) tryPlay();
      else v.addEventListener('loadeddata', tryPlay, { once: true });

      // Fallback: if video hasn't started playing in 4s, fade it out to show gradient bg
      setTimeout(function () {
        if (!playing && v.paused) {
          v.style.transition = 'opacity .6s ease';
          v.style.opacity = '0';
        }
      }, 4000);

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && v.paused && playing) tryPlay();
      });
    });
  }

  // ---------- Hero: rotating slideshow (images time out; videos play start-to-end) ----------
  function initHeroSlideshow() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(function (media) {
      var slides = Array.prototype.slice.call(media.querySelectorAll('[data-hero-slide]'));
      if (slides.length < 2) return;
      var duration = (parseFloat(media.getAttribute('data-slide-duration')) || 8) * 1000;
      var current = 0;
      var timer;
      var endedHandler;

      function advance() {
        current = (current + 1) % slides.length;
        activate(current);
      }

      function activate(index) {
        clearTimeout(timer);
        slides.forEach(function (slide, i) {
          var isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          var video = slide.querySelector('video');
          if (video && endedHandler) video.removeEventListener('ended', endedHandler);
          if (!video) return;
          if (!isActive) { video.pause(); return; }
          video.currentTime = 0;
          endedHandler = function () { advance(); };
          video.addEventListener('ended', endedHandler, { once: true });
          video.play().catch(function () {
            // Autoplay blocked — don't get stuck forever, fall back to the timed advance.
            timer = setTimeout(advance, duration);
          });
        });
        if (!slides[index].querySelector('video')) {
          timer = setTimeout(advance, duration);
        }
      }

      activate(current);
    });
  }

    // ---------- Header: transparent-over-hero on homepage ----------
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    var hero = document.querySelector('.hero--bottom');
    if (!header || !hero || !document.body.classList.contains('template-index')) return;
    function syncHeaderHeight() {
      document.documentElement.style.setProperty('--home-header-height', header.getBoundingClientRect().height + 'px');
    }
    function update() {
      header.classList.toggle('is-solid', window.scrollY > window.innerHeight - 90);
    }
    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(syncHeaderHeight).observe(header);
    window.addEventListener('scroll', update, { passive: true });
    update();
  }



  // ---------- Collections: scroll-pinned horizontal showcase (desktop only) ----------
  function initCollectionsCarousel() {
    var wrap = document.querySelector('[data-coll-scroll]');
    var pin = wrap ? wrap.querySelector('.coll-scroll-pin') : null;
    var grid = wrap ? wrap.querySelector('.coll-grid') : null;
    if (!wrap || !pin || !grid) return;

    var header = document.querySelector('.site-header');
    var NAV_HEIGHT = header ? header.offsetHeight : 66;
    var isDesktop = function () { return window.innerWidth >= 900; };

    var active = false;
    var trackDistance = 0;
    var pinHeight = 0;
    var pinTop = 0;
    var targetX = 0;
    var currentX = 0;
    var rafPending = false;

    function measure() {
      wrap.classList.add('pin-mode');
      pin.style.top = '';
      pinHeight = pin.offsetHeight;
      pinTop = Math.max(NAV_HEIGHT, (window.innerHeight - pinHeight) / 2);
      pin.style.top = pinTop + 'px';
      trackDistance = Math.max(0, grid.scrollWidth - pin.clientWidth);
      if (trackDistance <= 0) { disable(); return; }
      active = true;
      wrap.style.height = (pinHeight + trackDistance) + 'px';
    }

    function disable() {
      active = false;
      wrap.classList.remove('pin-mode');
      wrap.style.height = '';
      pin.style.top = '';
      grid.style.transform = '';
      targetX = 0; currentX = 0;
    }

    function updateTarget() {
      var total = wrap.offsetHeight - pinHeight;
      if (total <= 0) { targetX = 0; return; }
      var rect = wrap.getBoundingClientRect();
      var progress = Math.min(1, Math.max(0, (pinTop - rect.top) / total));
      targetX = -progress * trackDistance;
    }

    function tick() {
      rafPending = false;
      if (!active) return;
      updateTarget();
      currentX += (targetX - currentX) * 0.22;
      if (Math.abs(targetX - currentX) < 0.5) currentX = targetX;
      grid.style.transform = 'translateX(' + currentX + 'px)';
      if (currentX !== targetX) scheduleTick();
    }

    function scheduleTick() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(tick);
    }

    function onScroll() { if (active) scheduleTick(); }

    function evaluate() {
      if (!isDesktop()) { disable(); return; }
      measure();
      updateTarget();
      currentX = targetX;
      grid.style.transform = 'translateX(' + currentX + 'px)';
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', evaluate);
    evaluate();
  }

  // ---------- Angel Numbers picker ----------
  function initAngelNumbers() {
    var section = document.querySelector('[data-angel-numbers]');
    var picker = section ? section.querySelector('[data-angel-picker]') : null;
    if (!section || !picker) return;

    var tagEl = section.querySelector('[data-angel-tag]');
    var titleEl = section.querySelector('[data-angel-title]');
    var lineEl = section.querySelector('[data-angel-line]');
    var ctaEl = section.querySelector('[data-angel-cta]');
    var ghostEl = section.querySelector('[data-angel-ghost]');
    var imgEl = section.querySelector('[data-angel-image]');
    var photoEl = section.querySelector('.angel__panel-photo');
    var placeholderEl = section.querySelector('[data-angel-placeholder]');
    var preloadedImages = {};
    var preloadingStarted = false;

    function imageForTile(tile) {
      var mobileImg = tile.getAttribute('data-mobile-image');
      return window.matchMedia('(max-width: 767px)').matches && mobileImg
        ? mobileImg
        : tile.getAttribute('data-image');
    }

    function preloadImages() {
      picker.querySelectorAll('[data-angel-tile]').forEach(function (tile) {
        var url = imageForTile(tile);
        if (!url || preloadedImages[url]) return;
        var image = new Image();
        preloadedImages[url] = image;
        image.src = url;
      });
    }

    function apply(tile) {
      var tone = tile.getAttribute('data-tone');
      var soft = tile.getAttribute('data-soft');
      section.style.background = 'linear-gradient(170deg, ' + soft + ' 0%, ' + tone + '55 100%)';
      if (photoEl) photoEl.style.backgroundColor = soft;

      picker.querySelectorAll('[data-angel-tile]').forEach(function (t) {
        var on = t === tile;
        t.classList.toggle('is-active', on);
        t.style.borderColor = on ? t.getAttribute('data-tone') : 'transparent';
      });

      tagEl.textContent = tile.getAttribute('data-tag');
      titleEl.textContent = tile.getAttribute('data-title');
      lineEl.textContent = tile.getAttribute('data-line');
      ctaEl.textContent = tile.getAttribute('data-cta');
      ctaEl.setAttribute('href', tile.getAttribute('data-cta-link') || '#');
      ghostEl.textContent = tile.getAttribute('data-tag').split(' ')[0];

      var img = imageForTile(tile);
      if (img) {
        imgEl.src = img;
        imgEl.classList.remove('hidden');
        if (placeholderEl) placeholderEl.classList.add('hidden');
      } else {
        imgEl.classList.add('hidden');
        if (placeholderEl) placeholderEl.classList.remove('hidden');
      }
    }

    picker.querySelectorAll('[data-angel-tile]').forEach(function (tile) {
      tile.addEventListener('click', function () { apply(tile); });
    });

    var angelMobileQuery = window.matchMedia('(max-width: 767px)');
    angelMobileQuery.addEventListener('change', function () {
      var activeTile = picker.querySelector('[data-angel-tile].is-active');
      if (activeTile) apply(activeTile);
      if (preloadingStarted) preloadImages();
    });

    var first = picker.querySelector('[data-angel-tile]');
    if (first) apply(first);

    if ('IntersectionObserver' in window) {
      var preloadObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        preloadingStarted = true;
        preloadImages();
        preloadObserver.disconnect();
      }, { rootMargin: '600px 0px' });
      preloadObserver.observe(section);
    } else {
      preloadingStarted = true;
      preloadImages();
    }
  }

  // ---------- Reviews carousel ----------
  function initReviewsCarousel() {
    var carousel = document.querySelector('[data-revcar]');
    var dataEl = document.querySelector('[data-revcar-data]');
    if (!carousel || !dataEl) return;
    var reviews;
    try { reviews = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!reviews || reviews.length === 0) return;

    var slide = carousel.querySelector('[data-revcar-slide]');
    var quoteEl = carousel.querySelector('[data-revcar-quote]');
    var avatarEl = carousel.querySelector('[data-revcar-avatar]');
    var nameEl = carousel.querySelector('[data-revcar-name]');
    var roleEl = carousel.querySelector('[data-revcar-role]');
    var dotsWrap = carousel.querySelector('[data-revcar-dots]');

    var rev = 0;
    var fadeTimer, advanceTimer;

    function applySlide() {
      var r = reviews[rev];
      var idx = r.highlight ? r.quote.indexOf(r.highlight) : -1;
      if (idx >= 0) {
        quoteEl.innerHTML = escapeHtml(r.quote.slice(0, idx)) + '<span class="revcar__hl">' + escapeHtml(r.highlight) + '</span>' + escapeHtml(r.quote.slice(idx + r.highlight.length));
      } else {
        quoteEl.textContent = r.quote;
      }
      avatarEl.style.background = r.color || 'var(--primary)';
      avatarEl.textContent = r.initial || '';
      nameEl.textContent = r.name || '';
      roleEl.textContent = r.role || '';
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) { dot.classList.toggle('is-active', i === rev); });
    }

    function show(i) {
      slide.style.opacity = '0';
      clearTimeout(fadeTimer);
      fadeTimer = setTimeout(function () { rev = i; applySlide(); slide.style.opacity = '1'; }, 220);
    }
    function next() { show((rev + 1) % reviews.length); }
    function resetTimer() { clearInterval(advanceTimer); advanceTimer = setInterval(next, 5200); }
    function goto(i) { if (i === rev) return; resetTimer(); show(i); }

    reviews.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show review');
      dot.textContent = '✦';
      dot.addEventListener('click', function () { goto(i); });
      dotsWrap.appendChild(dot);
    });

    applySlide();
    resetTimer();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- Search overlay: full-screen search (real predictive search + real recent searches) ----------
  function initSearchOverlay() {
    var trigger = document.getElementById('searchTrigger');
    var overlay = document.getElementById('searchOverlay');
    if (!trigger || !overlay) return;

    var predictiveUrl = overlay.getAttribute('data-predictive-search-url');
    var searchUrl = overlay.getAttribute('data-search-url');
    var angelUrl = overlay.getAttribute('data-angel-url');

    var input = document.getElementById('overlaySearchInput');
    var squiggle = document.getElementById('overlaySquiggle');
    var clearBtn = document.getElementById('overlayClear');
    var closeBtn = document.getElementById('overlayClose');
    var defaultView = document.getElementById('overlayDefault');
    var resultsView = document.getElementById('overlayResults');
    var recentBlock = document.getElementById('overlayRecentBlock');
    var recentWrap = document.getElementById('overlayRecent');
    var angelBlock = document.getElementById('overlayAngelBlock');
    var angelHitsWrap = document.getElementById('overlayAngelHits');
    var collBlock = document.getElementById('overlayCollBlock');
    var collHitsWrap = document.getElementById('overlayCollHits');
    var productBlock = document.getElementById('overlayProductBlock');
    var productHitsWrap = document.getElementById('overlayProductHits');
    var emptyBlock = document.getElementById('overlayEmpty');
    var emptyText = document.getElementById('overlayEmptyText');

    var ANGEL = [];
    var angelDataEl = overlay.querySelector('[data-angel-numbers-data]');
    if (angelDataEl) {
      try { ANGEL = JSON.parse(angelDataEl.textContent); } catch (e) { ANGEL = []; }
    }

    var RECENT_KEY = 'boh:recentSearches';
    function getRecent() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
    }
    function saveRecent(term) {
      term = (term || '').trim();
      if (!term) return;
      var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      list = list.slice(0, 5);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
    }

    function renderRecent() {
      var list = getRecent();
      recentBlock.classList.toggle('hidden', list.length === 0);
      if (list.length === 0) return;
      recentWrap.innerHTML = list.map(function (t) {
        return '<button type="button">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#8A6FB0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/><path d="M12 8v4l3 2"/></svg>' +
          escapeHtml(t) + '</button>';
      }).join('');
      Array.prototype.forEach.call(recentWrap.children, function (btn, i) {
        btn.addEventListener('click', function () {
          input.value = list[i];
          input.focus();
          renderQuery(list[i]);
        });
      });
    }

    var searchToken = 0;
    function renderQuery(query) {
      var q = query.trim();
      var hasQuery = q.length > 0;

      squiggle.classList.toggle('hidden', !hasQuery);
      clearBtn.classList.toggle('hidden', !hasQuery);
      defaultView.classList.toggle('hidden', hasQuery);
      resultsView.classList.toggle('hidden', !hasQuery);

      if (!hasQuery) return;

      var qLower = q.toLowerCase();
      var angelHits = ANGEL.filter(function (a) {
        return a.num.indexOf(qLower) > -1 || a.label.toLowerCase().indexOf(qLower) > -1 || a.title.toLowerCase().indexOf(qLower) > -1;
      });
      angelBlock.classList.toggle('hidden', angelHits.length === 0);
      angelHitsWrap.innerHTML = angelHits.map(function (a) {
        return '<button type="button" class="search-overlay-angel-hit" data-href="' + escapeHtml(a.url) + '">' +
          '<span class="ah-num">' + escapeHtml(a.num) + '</span>' +
          '<span><span class="ah-label">' + escapeHtml(a.label) + '</span><span class="ah-title">' + escapeHtml(a.title) + '</span></span>' +
          '</button>';
      }).join('');
      Array.prototype.forEach.call(angelHitsWrap.children, function (btn) {
        btn.addEventListener('click', function () {
          saveRecent(q);
          close();
          location.href = btn.getAttribute('data-href') || angelUrl;
        });
      });

      if (!predictiveUrl) {
        collBlock.classList.add('hidden');
        productBlock.classList.add('hidden');
        emptyBlock.classList.toggle('hidden', angelHits.length > 0);
        return;
      }

      var token = ++searchToken;
      var url = predictiveUrl + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=8' +
        '&resources[options][unavailable_products]=last';

      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (token !== searchToken) return;
          var results = (data && data.resources && data.resources.results) || {};
          var collections = results.collections || [];
          var products = results.products || [];

          collBlock.classList.toggle('hidden', collections.length === 0);
          collHitsWrap.innerHTML = collections.map(function (c) {
            var img = (c.featured_image && c.featured_image.url) || c.featured_image || c.image || '';
            return '<a href="' + escapeHtml(c.url) + '" class="search-overlay-coll-hit">' +
              '<div class="ch-photo">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') + '</div>' +
              '<div class="ch-name">' + escapeHtml(c.title) + '</div>' +
              '</a>';
          }).join('');
          Array.prototype.forEach.call(collHitsWrap.querySelectorAll('a'), function (a) {
            a.addEventListener('click', function () { saveRecent(q); close(); });
          });

          productBlock.classList.toggle('hidden', products.length === 0);
          productHitsWrap.innerHTML = products.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.featured_image || p.image || '';
            return '<a href="' + escapeHtml(p.url) + '" class="search-overlay-product-hit">' +
              '<div class="ph-photo">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') + '</div>' +
              '<div class="ph-name">' + escapeHtml(p.title) + '</div>' +
              '<div class="ph-meta"><span class="ph-price">' + escapeHtml(p.price || '') + '</span></div>' +
              '</a>';
          }).join('');
          Array.prototype.forEach.call(productHitsWrap.querySelectorAll('a'), function (a) {
            a.addEventListener('click', function () { saveRecent(q); close(); });
          });

          var total = angelHits.length + collections.length + products.length;
          emptyBlock.classList.toggle('hidden', total > 0);
          if (total === 0) emptyText.textContent = 'We peeked under the beds and inside every sock and still couldn’t find “' + q + '”. Wanna try another word?';
        })
        .catch(function () { /* ignore network errors — angel hits (if any) still show */ });
    }

    var reelVideos = overlay.querySelectorAll('.reel-video');
    function playAllReels() {
      Array.prototype.forEach.call(reelVideos, function (video) { video.play().catch(function () {}); });
    }
    function pauseAllReels() {
      Array.prototype.forEach.call(reelVideos, function (video) { video.pause(); });
    }

    var debounceTimer;
    function open() {
      document.body.style.overflow = 'hidden';
      overlay.classList.remove('hidden');
      input.value = '';
      renderRecent();
      renderQuery('');
      input.focus();
      playAllReels();
    }
    function close() {
      document.body.style.overflow = '';
      overlay.classList.add('hidden');
      pauseAllReels();
    }

    trigger.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    clearBtn.addEventListener('click', function () { input.value = ''; input.focus(); renderQuery(''); });
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var val = input.value;
      debounceTimer = setTimeout(function () { renderQuery(val); }, 250);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim()) {
        saveRecent(input.value);
        close();
        location.href = searchUrl + '?q=' + encodeURIComponent(input.value.trim());
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.classList.contains('hidden')) close();
    });
  }

  // ---------- Footer: collapsible link columns (mobile) ----------
  function initFooterAccordion() {
    document.querySelectorAll('[data-foot-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.closest('.foot-col').querySelector('[data-foot-body]');
        if (!body) return;
        var open = body.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  // ---------- Explore collections: discoverable horizontal rail ----------
  function initCollectionRails() {
    document.querySelectorAll('[data-collection-rail-stage]').forEach(function (stage) {
      if (stage.dataset.railReady === 'true') return;
      var rail = stage.querySelector('[data-collection-rail]');
      var prev = stage.querySelector('[data-collection-rail-prev]');
      var next = stage.querySelector('[data-collection-rail-next]');
      if (!rail || !prev || !next) return;
      stage.dataset.railReady = 'true';

      function step() {
        var card = rail.querySelector('.collection-rail-card');
        if (!card) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        var max = rail.scrollWidth - rail.clientWidth;
        prev.hidden = rail.scrollLeft <= 2;
        next.hidden = max <= 2 || rail.scrollLeft >= max - 2;
      }

      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  // ---------- Hanging magnets: one calm entrance, then stay still ----------
  function initHangingMagnets() {
    document.querySelectorAll('[data-hanging-magnets]').forEach(function (section) {
      if (section.dataset.magnetsReady === 'true') return;
      section.dataset.magnetsReady = 'true';

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-visible');
          observer.unobserve(section);
        });
      }, { threshold: 0.2 });
      observer.observe(section);
    });
  }

  // ---------- Shop page: filter sidebar toggle + facet accordions ----------
  function initShopFilters() {
    var toggles = document.querySelectorAll('[data-filters-toggle]');
    var sidebar = document.querySelector('[data-shop-sidebar]');
    var grid = document.querySelector('.shop-grid');

    function replayCardEntrance() {
      if (!grid) return;
      var cards = grid.querySelectorAll('.product-card');
      cards.forEach(function (card) {
        card.style.animation = 'none';
        void card.offsetWidth;
        card.style.animation = '';
      });
    }

    function setSidebar(show) {
      if (!sidebar) return;
      sidebar.classList.toggle('hidden', !show);
      toggles.forEach(function (t) {
        t.setAttribute('aria-expanded', show ? 'true' : 'false');
        var label = t.querySelector('[data-filters-toggle-label]');
        if (label) label.textContent = show ? 'Hide filters' : 'Show filters';
      });
      document.body.classList.toggle('shop-filters-open', show);
      replayCardEntrance();
    }

    if (sidebar) {
      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () { setSidebar(sidebar.classList.contains('hidden')); });
      });
      document.querySelectorAll('[data-shop-sidebar-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { setSidebar(false); });
      });
    }
    document.querySelectorAll('[data-facet-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.parentElement.querySelector('.shop-facet-options');
        if (!body) return;
        var open = !body.hidden;
        body.hidden = open;
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var sign = btn.querySelector('.shop-facet-sign');
        if (sign) sign.textContent = open ? '+' : '–';
      });
    });

    var sortDetails = document.querySelector('[data-shop-sort]');
    if (sortDetails) {
      document.addEventListener('click', function (e) {
        if (sortDetails.hasAttribute('open') && !sortDetails.contains(e.target)) sortDetails.removeAttribute('open');
      });
    }
  }

  // ---------- Boot ----------
  function boot() {
    initMobileNav();
    initMobileNavAccordion();
    initCart();
    initProductForm();
    initGallery();
    initLightbox();
    initStickyBuy();
    initFallbackSize();
    initQtyStepper();
    initSizeChart();
    initRecentlyViewed();
    initPincode();
    initReviewsMore();
    initReveal();
    initHeroVideo();
    initHeroSlideshow();
    initHeaderScroll();
    initCollectionsCarousel();
    initAngelNumbers();
    initReviewsCarousel();
    initShopFilters();
    initSearchOverlay();
    initFooterAccordion();
    initCollectionRails();
    initHangingMagnets();
  }


  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
